import { render, staticRenderFns } from "./answerQuestions.vue?vue&type=template&id=46d1a4e6&scoped=true&"
import script from "./answerQuestions.vue?vue&type=script&lang=js&"
export * from "./answerQuestions.vue?vue&type=script&lang=js&"
import style0 from "./answerQuestions.vue?vue&type=style&index=0&id=46d1a4e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1a4e6",
  null
  
)

export default component.exports